import CustomerPage from '../pages/CustomerPage'
import ProductPage from '../pages/ProductPage'
import PaymentPage from '../pages/PaymentPage'
import ThankYouPage from '../pages/ThankYouPage'
import ErrorPage from '../pages/ErrorPage'

const routeList = [
  { path: "/error", component: ErrorPage },
  { path: "/thankYou", component: ThankYouPage },
  { path: "/payment", component: PaymentPage },
  { path: "/product", component: ProductPage },
  { path: "/", component: CustomerPage }
];

export default routeList;